import clienteAxios from "../config/axios";

export async function getAllPlataformas() {
    return clienteAxios.get('/plataforma');
}

export async function updatePlataforma(plataforma) {
    return clienteAxios.put(`/plataforma`, { id: plataforma._id, updates: plataforma });
}

export async function addPlataforma(plataforma) {
    return clienteAxios.post(`/plataforma`, { plataforma });
}

export async function deletePlataforma(plataforma) {
    return clienteAxios.delete(`/plataforma`, { data: { id: plataforma._id } });
}

export async function getPlataformaStats() {
    return clienteAxios.get('/plataforma/stats');
}
